import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import moment from 'moment-timezone'
import chunk from 'lodash/chunk'
import classNames from 'classnames'
import wind from './icons/wind-arrow.svg'
import drop from './icons/drop.svg'
import rain from './icons/rain.svg'

const degreeSymbol = '\u00B0'

// Define a function to calculate the average or sum of a property in a list of Immutable Maps
const calculateAverageOrSum = (data, property, isSum = false) => {
  const total = data.reduce((acc, item) => {
    const value = parseFloat(item.get(property))
    return typeof value === 'number' ? acc + value : acc
  }, 0)

  return isSum ? total : total / (data.length || 1)
}

const WeatherHourly = ({dailyData, onComponentClick}) => {
  const forecastAverages = chunk(dailyData.get('forecasts').toArray(), 3).map((threeHourly) => {
    const averageTemp = calculateAverageOrSum(threeHourly, 'temperature')
    const averageFeelsLike = calculateAverageOrSum(threeHourly, 'feelsLike')
    const averageWindSpeed = Math.round(calculateAverageOrSum(threeHourly, 'windSpeed'))
    const averagePrecipitation = Math.round(calculateAverageOrSum(threeHourly, 'precipitation', true) * 10) / 10
    const averagePrecipitationProbability = Math.round(calculateAverageOrSum(threeHourly, 'precipitationProbability'))
    const time = moment(threeHourly[0].get('datetime'))
    const temperature = (averageTemp > 0 ? '+' : '') + Math.floor(averageTemp) + degreeSymbol
    const feelsLike = (averageFeelsLike > 0 ? '+' : '') + Math.floor(averageFeelsLike) + degreeSymbol

    return {
      averageWindSpeed,
      averagePrecipitation,
      averagePrecipitationProbability,
      time,
      temperature,
      feelsLike,
      threeHourly,
    }
  })

  return (
    <button className='weekly-weather-day__hourly' onClick={ onComponentClick }>
      <ul>
        { forecastAverages.map(({ time, temperature, feelsLike, averageWindSpeed, averagePrecipitation, averagePrecipitationProbability, threeHourly }) => (
          <li className='weekly-weather-day__hourly-hour' key={ time.valueOf() }>
            <div className='weather-time'>
              <time title={ time.format('dd D.M.') + ' klo ' + time.format('HH') } dateTime={ time.toISOString() }>
                { time.format('HH') }
              </time>
            </div>
            <span className='weather-symbol'>
              <span className={ classNames(threeHourly[0].get('symbol')) } />
            </span>

            <div className='weather-temperature-container'>
              <div className='weather-temperature'>{ temperature }</div>
              <div className='weather-temperature-feelslike'>{ 'Tuntuu: ' + feelsLike }</div>
            </div>

            <div className='weather-wind'>
              <span
                className={ classNames(
                  'weather-wind__image__wrapper',
                  'weather-wind-direction',
                  threeHourly[0].get('windDirection')
                ) }
                aria-hidden='true'
              >
                <img
                  alt='wind-arrow'
                  src={ wind }
                  width={ 15 }
                  height={ 15 }
                  loading='lazy'
                />
              </span>
              <span className='weather-value'>{ averageWindSpeed + ' m/s' }</span>
            </div>

            <div className='weather-min-max-rain-change'>
              <span className='weather-min-max-rain-change__image__wrapper'>
                <img
                  className='weather-min-max-rain-change__image'
                  alt='drop'
                  src={ drop }
                  width={ 15 }
                  height={ 15 }
                  loading='lazy'
                />
              </span>
              <span className='weather-value'>{ averagePrecipitation + ' mm' }</span>
            </div>

            <div className='weather-precipitation-probability'>
              <span className='weather-precipitation-probability__image__wrapper'>
                <img
                  alt='rain'
                  src={ rain }
                  width={ 15 }
                  height={ 15 }
                  loading='lazy'
                />
              </span>
              <span className='weather-value'>{ averagePrecipitationProbability + ' %' }</span>
            </div>
          </li>
        )) }
      </ul>
    </button>
  )
}

WeatherHourly.propTypes = exact({
  dailyData: ImmutablePropTypes.map.isRequired,
  onComponentClick: PropTypes.func.isRequired,
})

export default React.memo(WeatherHourly)
